import { LineSpinner } from "ldrs/react";
import "ldrs/react/LineSpinner.css";
import s from "./MPArticleSkeleton.module.css";

const MPArticleSkeleton = () => {
  return (
    <div className={s.loadingOverlay}>
      <div className={s.loadingContent}>
        <LineSpinner size="40" stroke="3" speed="1" color="black" />
        <p className={s.loadingText}>Загрузка статьи...</p>
      </div>
    </div>
  );
};

export default MPArticleSkeleton;
